import { clearBehaviorCache as clearBehaviorCacheOriginal } from '../../behaviors/src/index';

/**
 * This utility file exists to break a dependency cycle between:
 * - configBehaviors.js (which imports from storeRegistration.js)
 * - configBehaviorReducer.js (which needs to clear behavior and configBehavior caches)
 * - storeRegistration.js (which imports reducers)
 *
 * By creating this intermediary utility that both files can import,
 * we avoid the circular dependency while maintaining the same functionality.
 */

// Registry for config behavior clearing functions
const clearConfigBehaviorsRegistry = {
  clearFunction: null
};

/**
 * Register a function to clear config behaviors
 * @param {Function} clearFunc Function that will clear the configBehaviors
 */
const registerClearConfigBehaviors = clearFunc => {
  clearConfigBehaviorsRegistry.clearFunction = clearFunc;
};

/**
 * Clear both the behavior cache and registered config behaviors
 * @param {Object} db Optional database parameter
 */
const clearAllBehaviorCaches = db => {
  // Clear the original behavior cache
  clearBehaviorCacheOriginal(db);

  // Also clear config behaviors if a function is registered
  if (clearConfigBehaviorsRegistry.clearFunction) {
    clearConfigBehaviorsRegistry.clearFunction(db);
  }
};
export default {
  clearAllBehaviorCaches,
  registerClearConfigBehaviors
};